// Tracking de conversiones: Google Ads (gtag) + Meta Pixel Purchase.
// Reglas: pedidos de prueba no cuentan; cada pedido dispara una sola vez
// (flag en localStorage por transaction_id); MP online solo si el pago está aprobado.

export function phoneE164AR(tel) {
  let d = (tel || "").replace(/\D/g, "").replace(/^0+/, "");
  if (d.startsWith("549")) return `+${d}`;
  if (d.startsWith("54")) return `+549${d.slice(2)}`;
  if (d.startsWith("15") && d.length >= 10) d = d.slice(2);
  return `+549${d}`;
}

export function ensureGtag(id) {
  if (!id || document.getElementById("gads-gtag")) return;
  const s = document.createElement("script");
  s.id = "gads-gtag";
  s.async = true;
  s.src = `https://www.googletagmanager.com/gtag/js?id=${id}`;
  document.head.appendChild(s);
  window.dataLayer = window.dataLayer || [];
  window.gtag = window.gtag || function () { window.dataLayer.push(arguments); };
  window.gtag("js", new Date());
  window.gtag("config", id);
}

export function fireConversiones(order, googleAds) {
  if (!order || order.esPrueba) return;
  const key = `bp_conv_${order.codigo}`;
  if (localStorage.getItem(key)) return;

  const tipo = order.pagoDetalle?.tipo || (order.metodoPago === "efectivo" ? "efectivo" : null);
  const esOnline = tipo !== "efectivo" && tipo !== "transferencia";
  // Mercado Pago online: la conversión solo cuenta cuando el pago volvió aprobado
  if (esOnline && order.estado !== "pagado") return;

  localStorage.setItem(key, String(Date.now()));

  if (googleAds?.activo && googleAds?.id && googleAds?.conversionLabel) {
    ensureGtag(googleAds.id);
    if (window.gtag) {
      // conversiones mejoradas: SHA-256 del teléfono E.164 calculado en el servidor
      if (order.telefonoHash) {
        window.gtag("set", "user_data", { sha256_phone_number: order.telefonoHash });
      }
      window.gtag("event", "conversion", {
        send_to: `${googleAds.id}/${googleAds.conversionLabel}`,
        value: order.total,
        currency: "ARS",
        transaction_id: order.codigo,
      });
    }
  }

  if (window.fbq) {
    window.fbq("track", "Purchase", { value: order.total, currency: "ARS" }, { eventID: order.codigo });
  }
}
